import { motion } from "framer-motion";
import { CHAPTERS, IMAGES } from "../lib/site";

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="bg-[#FAF7F2] py-24 sm:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="eyebrow label text-[#2D4A3E] mb-6"
            >
              The Approach
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="font-display text-4xl sm:text-5xl leading-[1.05] tracking-tight text-[#1C1917]"
            >
              A philosophy of quiet, deliberate progress.
            </motion.h2>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="mt-10 overflow-hidden rounded-3xl"
            >
              <img src={IMAGES.session2} alt="Pilates session at home" className="w-full h-72 object-cover" />
            </motion.div>
          </div>

          <div className="lg:col-span-7 lg:pl-10">
            {CHAPTERS.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                data-testid={`manifesto-chapter-${c.n}`}
                className="flex gap-6 sm:gap-10 py-8 border-b border-[#1C1917]/10 last:border-b-0 group"
              >
                <span className="font-display text-5xl sm:text-6xl text-[#C5A059] leading-none w-16 shrink-0 transition-transform duration-500 group-hover:-translate-y-1">
                  {c.n}
                </span>
                <div>
                  <h3 className="font-display text-2xl sm:text-3xl text-[#1C1917] mb-3">{c.title}</h3>
                  <p className="text-[#57534E] text-base sm:text-lg leading-relaxed max-w-xl">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
